import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]

import { makeFirstLetterUpper } from '@/utils/main';
import { addMonths, format, subMonths } from 'date-fns';
import { ru } from 'date-fns/locale';
import { ref } from 'vue';
import store from '@/store';
import { reachGoal } from '@/utils/metrika';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaReportDrop',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {



const reportInProcess = ref<boolean>(false);

const currentDate = new Date();

// Генерация месяцев (предыдущий, текущий, следующий)
const months = [
  makeFirstLetterUpper(format(subMonths(currentDate, 1), 'LLLL', { locale: ru })),
  makeFirstLetterUpper(format(currentDate, 'LLLL', { locale: ru })),
  makeFirstLetterUpper(format(addMonths(currentDate, 1), 'LLLL', { locale: ru })),
];

// Генерация дат в формате YYYY-MM-DD (предыдущий, текущий, следующий)
const dates = [
  format(subMonths(currentDate, 1), 'yyyy-MM-01'),
  format(currentDate, 'yyyy-MM-01'),
  format(addMonths(currentDate, 1), 'yyyy-MM-01'),
];

// Суффиксы для цели метрики по индексу месяца (предыдущий, текущий, следующий)
const monthGoalSuffixes = ['prev', 'current', 'next']

// Обработка нажатия на ссылку
const getReportLink = async (startDate: string, monthIndex: number) => {
  try {
    reportInProcess.value = true;
    const url = await store.dispatch("data/getFRVReport", startDate)
    downloadReportFile(url)
    reachGoal(`sidenav-report-download-${monthGoalSuffixes[monthIndex]}`)
  } catch (error) {
    console.error(error);
  } finally {
    setTimeout(() => reportInProcess.value = false, 200)
  }
}

// Создаем элемент из полученного URL для скачивания
const downloadReportFile = (url: string) => {
  if (url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.click();
    link.remove();
  }
}

return (_ctx: any,_cache: any) => {
  return (__props.isOpen)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month, index) => {
          return _createElementVNode("li", { key: index }, [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(($event: any) => (getReportLink(dates[index], index)), ["prevent"]),
              class: _normalizeClass({'disabled' : reportInProcess.value}),
              "data-qa": "report-drop-link-download"
            }, _toDisplayString(month), 11, _hoisted_2)
          ])
        }), 64))
      ]))
    : _createCommentVNode("", true)
}
}

})